import { r as registerInstance, c as createEvent, h } from './index-5faac9d7.js';

const pesMobileCategoriesCss = ".pes-categories{color:#333333;background-color:#ffffff;border:1px solid #e7e6e6;list-style:none;margin:15px 13px 10px;padding:0}@media screen and (min-width: 980px){.pes-categories{display:none}}.pes-categories__item{margin:0;padding:0 15px}.pes-categories__button{border-bottom:1px solid #e7e6e6;display:block;font-weight:400;font-size:16px;line-height:20px;margin:0;padding:15px 0 14px;position:relative;text-transform:capitalize;width:100%}:host(:not([dir=\"rtl\"])) .pes-categories__button{text-align:left}:host([dir=\"rtl\"]) .pes-categories__button{text-align:right}.pes-categories__button::after{border-bottom:2px solid #9fa0a4;border-top-color:#9fa0a4;content:\"\";height:8px;opacity:0.7;position:absolute;top:35%;width:8px}:host(:not([dir=\"rtl\"])) .pes-categories__button::after{border-left-color:#9fa0a4;border-right:2px solid #9fa0a4;right:2px;transform:rotate(-45deg)}:host([dir=\"rtl\"]) .pes-categories__button::after{border-right-color:#9fa0a4;border-left:2px solid #9fa0a4;left:2px;transform:rotate(45deg)}";

const PesMobileCategories = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.selectCategory = createEvent(this, "selectCategory", 7);
    this.categories = undefined;
  }
  render() {
    var _a;
    if (((_a = this.categories) === null || _a === void 0 ? void 0 : _a.length) === 0)
      return;
    return (h("ul", { class: "pes-categories" }, this.categories.map((i) => (h("li", { class: "pes-categories__item" }, h("a", { class: "pes-categories__button", onClick: () => {
        this.selectCategory.emit(i.navigationState);
      } }, h("span", null, i.label)))))));
  }
};
PesMobileCategories.style = pesMobileCategoriesCss;

export { PesMobileCategories as pes_mobile_categories };
